var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_2571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.36361 4.26012V15.1145C2.36361 16.695 3.15353 18.171 4.46864 19.0478L10.6362 23.1595L16.8039 19.0478C18.119 18.171 18.9089 16.695 18.9089 15.1145V4.26012L10.6362 2.42176L2.36361 4.26012ZM0.925436 2.15844L10.6362 0.000488281L20.347 2.15844C20.8878 2.27861 21.2725 2.7582 21.2725 3.31211V15.1145C21.2725 17.4853 20.0876 19.6993 18.1149 21.0144L10.6362 26.0002L3.15755 21.0144C1.18489 19.6993 0 17.4853 0 15.1145V3.31211C0 2.7582 0.384713 2.27861 0.925436 2.15844Z",
    fill: "#343A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6362 7.09079L11.6975 10.3572H15.1321L12.3535 12.376L13.4148 15.6424L10.6362 13.6236L7.85763 15.6424L8.91895 12.376L6.14036 10.3572H9.57489L10.6362 7.09079Z",
    fill: "#88BDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_2571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2725,
    height: 26,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.2fb4c22e5a40a62592198dd12e5e49d3.svg";
export { ForwardRef as ReactComponent };